<ion-app>
  @if (isLoggedIn$ | async) {
    <div>Navigation</div>
  }
  <div>
    <ion-router-outlet></ion-router-outlet>
    @if (showLoading$ | async) {
      <work-ui-loading-spinner
        [iconSize]="40"
        [pageLoader]="true"
        loadingState="loading" />
    }
  </div>
  <work-ui-environment-ribbon />
  <ng-template workUiAlertDialogs></ng-template>
  <ng-template workUiConfirmActionModalHost></ng-template>
  <ng-template workUiModal></ng-template>
</ion-app>
